import { defineMessages } from "react-intl";

export const messages = defineMessages({
    migrationTicketsFiltersStatusPlaceholder: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.status-placeholder",
        defaultMessage: "Status",
        description: "Placeholder text for status filter dropdown"
    },
    migrationTicketsFiltersPhasePlaceholder: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.phase-placeholder",
        defaultMessage: "Migration phase",
        description: "Placeholder text for migration phase filter dropdown"
    },
    migrationTicketsFiltersClearFilters: {
        id: "fastshift.migration-tickets-page.migration-tickets-filters.clear-filters",
        defaultMessage: "Clear filters",
        description: "Text for clear all filters button"
    }
});
